export default __webpack_public_path__ + "static/img-testimonial-f83192eae6f2dc3a3b2756d02b25a9c2.webp";